import React from 'react';
import classNames from 'classnames';
import { useTranslations } from 'use-intl';

import { useFormattedDuration } from 'modules/global';

interface IProps {
  lessonCount?: number;
  duration?: number;
  className?: string;
}

export const Stats = ({ lessonCount, duration, className }: IProps) => {
  const t = useTranslations();
  const formatDuration = useFormattedDuration();

  return (
    <div className={classNames('flex items-center gap-2', className)}>
      <div className="rounded-md border border-gray-300 px-1.5 py-0.5 text-sm font-medium text-gray-500">
        {lessonCount ?? 0} {t('ta_dars')}
      </div>
      <div className="rounded-md border border-gray-300 px-1.5 py-0.5 text-sm font-medium text-gray-500">
        {t('test_soni')} - {lessonCount ?? 0} {t('ta')}
      </div>
      <div className="rounded-md border border-gray-300 px-1.5 py-0.5 text-sm font-medium text-gray-500">
        {t('kurs_davomiyligi')} - {formatDuration(duration)}
      </div>
    </div>
  );
};
